module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zoomImgObj.show),
      expression: "zoomImgObj.show"
    }]
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap.prevent",
      value: ({
        methods: _vm.closeZoomImg
      }),
      expression: "{ methods : closeZoomImg}",
      modifiers: {
        "prevent": true
      }
    }],
    staticClass: "maskLayer"
  }), _vm._v(" "), _c('img', {
    ref: "zoomImg",
    staticClass: "zoomImg",
    style: (_vm.styleObject),
    attrs: {
      "src": _vm.zoomImgObj.url
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-45734d4b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-45734d4b"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/composite/zoomImg/src/zoomImg.vue
// module id = 1067
// module chunks = 1